import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoadingSpinner from './LoadingSpinner';
import { isAuth0StateError, handleAuth0StateError, hasAuth0CallbackParams, cleanAuth0CallbackParams } from '../../utils/AuthUrlCleanup';

const AuthWrapper = ({ children }) => {
  const { isLoading, error } = useAuth0();

  // Clean Auth0 callback parameters on mount if present
  useEffect(() => {
    if (hasAuth0CallbackParams()) {
      cleanAuth0CallbackParams();
    }
  }, []);

  // Handle Auth0 state errors
  useEffect(() => {
    if (error && isAuth0StateError(error)) {
      handleAuth0StateError(error);
    }
  }, [error]);

  if (error) {
    const isStateError = isAuth0StateError(error);
    
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold text-red-500 mb-4">
            Authentication Error
          </h2>
          <p className="text-gray-300 mb-4">
            {error.message}
          </p>
          {isStateError && (
            <p className="text-yellow-400 mb-6 text-sm">
              This appears to be a state validation error. Try refreshing the page or clearing your browser cache.
            </p>
          )}
          <div className="space-y-3">
            <button
              className="block w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
            {isStateError && (
              <button
                className="block w-full px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded transition-colors"
                onClick={() => {
                  // Clear Auth0 localStorage and reload
                  Object.keys(localStorage).forEach(key => {
                    if (key.includes('auth0')) {
                      localStorage.removeItem(key);
                    }
                  });
                  window.location.href = '/';
                }}
              >
                Clear Auth Data & Restart
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <LoadingSpinner message="Initializing authentication..." />;
  }

  return children;
};

export default AuthWrapper;

